import React, { Component } from 'react';
import Navegacao from '../components/Navegacao.js';
import central from '../api/Central.js';
import Alert from '../components/Alert.js';

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            login: null
        }
    }

    login(evt) {
        this.setState({ disabled: true });
        central.login(this.state.login,
            (usuario) => {
            },
            (msgFalha) => {
                this.setState({ erro: msgFalha });
                console.log(msgFalha)
            },
            () => { this.setState({ disabled: false }) });

    }

    handleChange(event) {
        console.log("State: " + event.target.value);
        this.setState({ login: event.target.value });
    }

    render() {
        return (
            <section className="container">
                <Navegacao link="/" titulo="Identifique-se" />
                <form>
                    <fieldset>
                        <label htmlFor="cpf">Digite seu CPF ou CNPJ</label>
                        <input onChange={this.handleChange.bind(this)} type="text" mask="###.###.###-##" id="cpf" />
                        { this.state.erro && (<Alert type="error">{this.state.erro}</Alert>)}
                    </fieldset>
                    <button disabled={this.state.disabled} type="submit" onClick={this.login.bind(this)}>Entrar</button>
                </form>
            </section>
        );
    }
}

export default Login;